<template>
  <div id="app">
    <!-- <v-header v-if="isRouterAlive"></v-header> -->
    <!-- <PersonalNav v-if="isRouterAlive"/>
    <TypeNav :obj="TypeRoute"/> -->
    <router-view></router-view>
    <!-- <VFoot :obj="FooterData"/> -->
  </div>
</template>
<script>
// import VHeader from '@/components/base/v-header'
// import VFoot from '@/components/base/v-foot'
// import PersonalNav from '@/components/common/TopPersonalNav'
// import TypeNav from '@/components/common/TopTypeNav'

export default {
  name: 'App',
  components: {},
  provide () {
    return {


      reload: this.reload
    }
  },
  data () {
    return {

      isRouterAlive: true,
      TypeRoute: {},
      FooterData: {}
    }
  },
  watch: {
    $route (to, from) {
      if (to.name !== from.name) {
        this.reload()
      }
    }
  },
  created () {
    //this.getCanvas()
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))))
  },
  methods: {


    // giveTypeRes (type, data) {
    //   var result
    //   for (var key in data) {
    //     if (data[key].type === type) {
    //       result = data[key]
    //     }
    //   }
    //   return result
    // },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">

#app{
  min-width: 1440px;
  background-color: #F6F6F8;
}
.el-loading-mask{
  .el-loading-spinner{
    .path{
      stroke: #333333;
    }
  }
}
// loading
.el-loading-spinner{
  i,.el-loading-text{
    font-size: 18px;
    color: #333333;
  }
}

  .pagination {
    padding: 30px 0;
    max-width: 1280px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue